import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { invalidateAgency } from '../../actions/agencyStubs';
import { setProfile } from '../../actions/profile';
import { clearError } from '../../actions/findError';

const Logout = () => {
  const { logout, isAuthenticated, isLoading } = useAuth0();
  const dispatch = useDispatch();

  console.log('[Logout.js] Rendered:', { isAuthenticated, isLoading });

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      console.log('[Logout.js] Clearing Redux state and logging out...');
      dispatch(invalidateAgency());
      dispatch(setProfile({}));
      dispatch(clearError());
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    }
  }, [dispatch, logout, isAuthenticated, isLoading]);

  return <div>Logging out...</div>;
};

export default Logout;